// extracted by mini-css-extract-plugin
export default {"root":"AutoDeleteFolderInformer__root--15aKR","date":"AutoDeleteFolderInformer__date--kMe8H"};